// Our chrome extension ID
export const CHROME_EXTENSION_ID = "bgmocpjdgcjmdjbklijdgnalkleckpbf"
export const EXTENSION_CWS_URL = `https://chrome.google.com/webstore/detail/tombo/${CHROME_EXTENSION_ID}`

export const ALL_BROWSER_EXTENSION_REDIRECT_URLS = []
// disabled since we don't do oauth inside the extension
// ALL_BROWSER_EXTENSION_IDS.map(
//   (id) => `https://${id}.chromiumapp.org`
// )
